import { useEffect } from 'react';
import { GAME_DB } from '../../db/game';
import { getGameState, sendTaskAnswersList, sendTaskAnswersTimeLogsList, } from '../../api/game-mode/game';
import { GAME_END_TIME } from '../../app.config.vars/stored';
import { setIsModalOpen, setModalContent, setIsSyncing } from '../../store/slices/global';
import { MODAL_CONTENT } from '../../app.config.vars/modalContent';
import { useAppDispatch } from '../../store';
export const useDataSync = () => {
    const dispatch = useAppDispatch();
    useEffect(() => {
        const syncIfOnline = async () => {
            if (navigator.onLine) {
                if (location.href.includes('admin')) {
                    return;
                }
                try {
                    const localTaskAnswers = await GAME_DB.GET.localTaskAnswers();
                    const localAnswersTimeLogs = await GAME_DB.GET.localAnswersTimeLogsList();
                    if (localTaskAnswers?.length || localAnswersTimeLogs?.length) {
                        dispatch(setIsSyncing(true));
                        if (localTaskAnswers?.length) {
                            const response = await sendTaskAnswersList({ answers: localTaskAnswers });
                            if (!response.error) {
                                await GAME_DB.UPDATE.clearLocalAnswers();
                            }
                        }
                        if (localAnswersTimeLogs?.length) {
                            const response = await sendTaskAnswersTimeLogsList({
                                timeLogs: localAnswersTimeLogs,
                            });
                            if (!response.error) {
                                await GAME_DB.UPDATE.clearLocalAnswersTimeLogs();
                                await getGameState();
                            }
                        }
                        dispatch(setIsSyncing(false));
                    }
                    if (!location.pathname.includes('game-result') &&
                        !location.pathname.includes('gameplay')) {
                        const unsavedGame = !!localStorage.getItem(GAME_END_TIME);
                        if (unsavedGame) {
                            dispatch(setIsModalOpen(true));
                            dispatch(setModalContent(MODAL_CONTENT.saveGameResult.key));
                        }
                    }
                }
                catch (error) {
                    console.log('Nothing to synchronize. Local DB is not initialize jet');
                    dispatch(setIsSyncing(false));
                }
            }
        };
        window.addEventListener('online', syncIfOnline);
        const interval = setInterval(syncIfOnline, 10000);
        syncIfOnline();
        return () => {
            window.removeEventListener('online', syncIfOnline);
            clearInterval(interval);
        };
    }, []);
};
